'use strict';

angular.module('adminBusinessUnitsRoutes', ['BusinessUnitsControllers',
                                               'services.authenticatedUser'])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('adminBusinessUnits', {
            url: '/Administration/BusinessUnit',
            resolve: {
                authenticatedUser: ['authenticatedUserService', function (service) {
                    return service.getAuthenticatedUser();
                }],
                businessUnits: ['adminBusinessUnitsService', function (businessUnitService) {
                    return businessUnitService.searchBusinessUnits('')
                             .then(function (businessUnits) {
                                 return businessUnits;
                             });
                }]
            },
            views: {
                '': {
                    template: '<div ui-view="mainContent"></div>',
                },
                'mainContent@adminBusinessUnits': {
                    templateUrl: require('./businessUnits.tpl.html'),
                    controller: 'BusinessUnitsController',
                },
            }
        })
        .state('adminBusinessUnits.businessUnitAdd', {
            url: '/Add',
            resolve: {
                businessUnit: function () {
                    return {};
                }
            },
            views: {
                'mainContent@adminBusinessUnits': {
                    templateUrl: require('./businessUnitEdit.tpl.html'),
                    controller: 'BusinessUnitEditController'
                }
            }
        })
        .state('adminBusinessUnits.businessUnitEdit', {
            url: '/{BusinessUnitID:int}',
            resolve: {
                businessUnit: ['$stateParams', 'adminBusinessUnitsService', function ($stateParams, adminBusinessUnitsService) {
                    return adminBusinessUnitsService
                           .getBusinessUnit($stateParams.BusinessUnitID)
                           .then(function (response) {
                               return response.data;
                           });
                }]
            },
            views: {
                'mainContent@adminBusinessUnits': {
                    templateUrl: require('./businessUnitEdit.tpl.html'),
                    controller: 'BusinessUnitEditController',
                },
            }
        });
}]);